import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

export function useDeleteRoom() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  async function deleteRoom({ id }: { id: string }) {
    const res = await apiClient.delete<undefined>(`/api/v1/rooms/${id}`)
    return res.data
  }

  return useMutation({
    mutationFn: deleteRoom,
    onSuccess: () => {
      toast.success({ message: t('roomDeleted') })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
    },
    onError
  })
}
